import React, { useState } from "react";
import leftSecImg from "../assets/images/fifth-sec-l-1.png";
import rightSecImg from "../assets/images/fifth-sec-r.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import user1 from "../assets/user/user1.png";
import user2 from "../assets/user/user2.png";
import "./SixSec.css";
import cautationMark from "../assets/images/feedback-icon.png";

export const FifthSec = () => {
  const [isGrabbing, setIsGrabbing] = useState(false);

  const handleMouseDown = () => setIsGrabbing(true);
  const handleMouseUp = () => setIsGrabbing(false);
  const handleMouseLeave = () => setIsGrabbing(false);
  return (
    <>
      <div id="testimonials" className=" m-auto py-14">
        <div
          className="grid md:grid-cols-2 grid-cols-1 gap-4"
          // style={{
          //   background: `url(${leftSecImg}) no-repeat left center`,
          //   backgroundSize: "contain",
          // }}
        >
          <div
            className="flex flex-col items-center md:items-end justify-center h-[400px] md:bg-[length:auto_450px] bg-[length:auto_200px]"
            style={{
              background: `url(${leftSecImg}) no-repeat left center`,
              backgroundSize: "contain",
            }}
          >
            <h3
              data-aos="fade-right"
              className="relative uppercase text-[70px] md:text-[90px] font-black m-0 leading-[70px] text-center drop-shadow-xl"
            >
              What <br />
              They're
            </h3>
            <button
              className="  rotate-[-7deg] bg-[#c0ff00] p-2 rounded-full flex items-center  drop-shadow-[0px_0px_3px_#808080]"
              // data-aos="fade-right"
            >
              <span className="drop-shadow-2xl uppercase text-[30px] md:text-[35px] font-bold bg-[#c0ff00] px-4 py-0 md:px-7 md:py-2 rounded-full border border-black border-dashed leading-8">
                Saying
              </span>
            </button>
          </div>

          <div>
            <div
              className="flex flex-col items-center justify-center h-[400px]"
              style={{
                background: `url(${rightSecImg}) no-repeat right bottom`,
                backgroundSize: "100px",
              }}
            >
              <Swiper
                data-aos="flip-right"
                effect={"cards"}
                // loop={true}
                grabCursor={true}
                modules={[EffectCards]}
                className="mySwiper reviewSwiper"
              >
                <SwiperSlide>
                  <div className="flex flex-col  pb-4 pt-8 px-6 h-full text-black tracking-wide">
                    <div className="flex items-center border-b border-black gap-4 mb-2   pb-4">
                      <div className="w-[30%] rounded-full swiper-div-img p-2">
                        <img
                          src={user1}
                          className="object-contain w-full"
                          alt="User 1"
                        />
                      </div>
                      <div className="text-left">
                        <h4 className="cursor-grab text-[23px]">Julian K.</h4>
                        <h6 className="cursor-grab text-[13px]">
                          CEO, LDCV GmbH
                        </h6>
                      </div>
                    </div>
                    <div className="text-center relative ">
                      <img
                        src={cautationMark}
                        alt="Caution Mark"
                        className="w-[30px] h-[30px]   top-[-15%] left-[-3%] "
                      />
                      <p className="cursor-grab text-[18px] tracking-wide">
                        Going above and beyond expectation, and quick
                        responsiveness was truly impressive. <br></br>
                        Highly recommend!
                      </p>
                      <img
                        src={cautationMark}
                        alt="Caution Mark"
                        className="w-[30px] h-[30px] ml-2 absolute right-0 bottom-[-20%]"
                      />
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="flex flex-col  pb-4 pt-8 px-6 h-full text-white tracking-wide">
                    <div className="flex items-center border-b border-white gap-4 mb-2 pb-4">
                      <div className="w-[30%] rounded-full swiper-div-img2 p-2">
                        <img
                          src={user2}
                          className="object-contain w-full"
                          alt="User 2"
                        />
                      </div>
                      <div className="text-left">
                        <h4 className="cursor-grab text-[23px]"> Helder S.</h4>
                        <h6 className="cursor-grab text-[13px]">
                          Founder, Newton AI
                        </h6>
                      </div>
                    </div>
                    <div className="text-center relative ">
                      <img
                        src={cautationMark}
                        alt="Caution Mark"
                        className="w-[30px] h-[30px]   top-[-15%] left-[-3%] white-color "
                      />
                      <p className="cursor-grab text-[18px] tracking-wide">
                        The attention to detail paired with quick communication
                        and seamless cooperation made the whole process a
                        breeze. <br></br>
                        absolutely top-notch!
                      </p>
                      <img
                        src={cautationMark}
                        alt="Caution Mark"
                        className="w-[30px] h-[30px] ml-2 absolute right-0 bottom-[-20%] white-color "
                      />
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="flex flex-col  pb-4 pt-8 px-6 h-full text-white tracking-wide">
                    <div className="flex items-center border-b border-white gap-4 mb-2 pb-4">
                      <div className="w-[30%] rounded-full swiper-div-img3 p-2">
                        <img
                          src={user1}
                          className="object-contain w-full"
                          alt="User 1"
                        />
                      </div>
                      <div className="text-left">
                        <h4 className="cursor-grab text-[23px]">Corbin W.</h4>
                        <h6 className="cursor-grab text-[13px]">
                          Director, CJW Global
                        </h6>
                      </div>
                    </div>
                    <div className="text-center relative ">
                      <img
                        src={cautationMark}
                        alt="Caution Mark"
                        className="w-[30px] h-[30px] top-[-15%] left-[-3%] white-color "
                      />
                      <p className="cursor-grab text-[18px] tracking-wide">
                        The best designer we have ever worked with.
                        <br />
                        We are definitely going to work with him again. He is
                        very fast and does a fantastic job.
                      </p>
                      <img
                        src={cautationMark}
                        alt="Caution Mark"
                        className="w-[30px] h-[30px] ml-2 absolute right-0 bottom-[-20%] white-color "
                      />
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
